


























































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import UserAD from '../services/userADDto'
import { UserProfileDto } from '@/interfaces/userProfileDto';
import { UserDto } from '@/interfaces/userDto';
import { ClaimEnum } from '@/services/ClaimEnum';
import ExternalUserInfo from './ExternalUser/ExternalUserInfo.vue';
import { CONTRACT_TYPE_ENUM } from '@/services/Enums';

@Component({
    components: {
        ExternalUserInfo
    }
})
export default class UserDetail extends Vue {
    @Prop()
    public username!: any;

    @Prop()
    idModel: string;

    @Prop()
    userProfile: UserProfileDto;

    @Prop()
    showClose: boolean;
    idRoleSelected: any = null;
    convertedRoles: any = null;
    allRoles: [];
    tabActivated: number;
    loading: boolean = true;
    contentADAvailable: boolean = false;
    contentRoleAvailable: boolean = false;
    userAD: UserAD = null;
    userAuth: UserDto = null;
    general: any = {};

    userInfoAD = {
        email: '',
        id: '',
        userRoles: [],
        userName: '',
    }

    close() {
        this.$bvModal.hide('user-detail-modal');
    }

    checkAuth() {
        return this.general.CheckAuthorization(ClaimEnum.CanImpersonate)
    }

    async mounted() {
        this.tabActivated = 0;
        
        if(this.userProfile.ContractType != CONTRACT_TYPE_ENUM.OUTER)
            await this.getDirectoryInfo(this.userProfile.Username);
        
        await this.getRolesUser(this.userProfile.Username);

        this.general = General;
        this.loading = false;
    }

    async getRolesUser(username: string) {
        try {
            let response = await axios.get(General.GetApiUrl('/api/Admin/SearchUserByUsername?username=' + username), { withCredentials: true })
            this.userInfoAD = response.data;
            this.contentRoleAvailable = true;
        }
        catch (ex) {
            if (ex.response.status == 404) {
                /*this.$fire({
                    title: "Error",
                    text: "User doesn't exist",
                    type: "error"
                })*/
                this.contentRoleAvailable = false;
            }
            else {
                this.contentRoleAvailable = false;
                /*this.$fire({
                    title: "Generic Error",
                    text: ex,
                    type: "error"
                })*/
            }
        }
    }

    async getDirectoryInfo(userNameToView: string) {
        try {
            let response = await axios.get(General.GetApiUrl('/api/Admin/SearchActiveDirectory?username=' + userNameToView), { withCredentials: true })
            this.userAD = response.data;
            this.contentADAvailable = true;

        }
        catch (ex) {
            if (ex.response.status == 404) {
                /*this.$fire({
                    title: "Error",
                    text: "User doesn't exists",
                    type: "error"
                })*/
                this.contentADAvailable = false;
            }
            else {
                /*this.$fire({
                    title: "Generic Error",
                    text: ex,
                    type: "error"
                })*/
            }
        }
        this.general = General;
    }
    async deleteRoleUser(idUser: string, idRoleToDelete: string) {
        try {
            await axios.get(General.GetApiUrl('/api/Admin/DeleteRoleById?idUser=' + idUser + '&idRoleToDelete=' + idRoleToDelete), { withCredentials: true })
            this.getRolesUser(this.userProfile.Username);
            General.showAlertSuccess("Role successfully removed", this);
        }
        catch (ex) {
            if (ex.response.status == 404) {
                this.$fire({
                    title: "Error",
                    text: "Role not found",
                    type: "error"
                })
            }
            else {
                this.$fire({
                    title: "Generic Error",
                    text: ex,
                    type: "error"
                })
            }
        }
    }
    async getAllRoles() {
        try {
            let response = await axios.get(General.GetApiUrl('/api/Admin/GetAllRoles'), { withCredentials: true })
            this.allRoles = response.data;
            this.convertedRoles = this.convertRoles(this.allRoles, this.userInfoAD.userRoles);
            this.viewRolesModal();
        }
        catch (ex) {
            if (ex.response.status == 404) {
                this.$fire({
                    title: "Error",
                    text: "No roles found",
                    type: "error"
                })
            }
            else {
                this.$fire({
                    title: "Generic Error",
                    text: ex,
                    type: "error"
                })
            }
        }
    }

    async viewRolesModal() {
        this.$bvModal.show('roles-modal');
    }
    async viewAddRoleModal() {
        this.$bvModal.show('add-role-modal');
    }

    async addRoleUser(idUser: string, idRoleSelected: string) {
        General.confirm("are you sure you want to add a Role to\"" + this.username + "\"?", this, async () => {
            try {
                await axios.get(General.GetApiUrl('/api/Admin/AddRoleUser?idUser=' + idUser + '&idRole=' + idRoleSelected), { withCredentials: true })

                General.showAlertSuccess('Role successfully added', this);
                this.getRolesUser(this.userProfile.Username);
                this.$bvModal.hide('add-role-modal');
            }
            catch (ex) {
                if (ex.response.status == 400) {
                    this.$fire({
                        title: "Error",
                        text: "Sorry, role already exist",
                        type: "error"
                    })
                }
                else {
                    this.$fire({
                        title: "Generic Error",
                        text: ex,
                        type: "error"
                    })
                    
                }
            }
        })
    }

    convertRoles(data: any, userRoles: any) {
        let outputData = new Array();
        outputData.push({
            value: null,
            text: "Select a role to add",
            disabled: true,
        });
        data.forEach(function (item) {
            let arrayRolesName = [];
            userRoles.forEach(function (item) {
                arrayRolesName.push(item.identityRole.name + '');
            });

            if(!arrayRolesName.includes(item.name)){
            outputData.push({
                value: item.id,
                text: item.name,
            });}
        });
        return outputData;
    }

    async impersonateDo() {

        let app = this;
        let username: string = this.userProfile.Username;

        if (username == null || username == app.$store.getters.getUser.Username) {
            General.showAlertDanger("You cannot impersonate yourself", this);
        } else {
            General.confirm("Do you want to impersonate \"" + username + "\"?", app, async () => {
                await General.StartImpersonate(username, app, this.$router);
            });
        }
    }
}
